import { PAYBACK_SERVICE_URL } from '../asb_modules/payback/PBApiConstants';
import { constants } from '../constants';
import { API } from './apiConstants';

const api = {
  Public: {
    getIban,
    getConfig,
    getConfigByVersion,
    sendSessionStatus,
    getActiveConfigByProjectName,
    sendTrackingData,
    getRequiredFonts,
    getActiveConfigTranslation,
    getSpecificConfigTranslation,
    getAllTranslationsForConfig,
    postClientLog,
    send2FACode,
    verify2FACode,
  },
};

let headers = new Headers();
headers.append('content-type', 'application/json');

function getIban(project, iban) {
  return fetch(`${PAYBACK_SERVICE_URL.V1.getIBANpath(project)}`, {
    body: '{ "iban": "' + iban + '"}',
    method: 'POST',
    headers: headers,
  });
}

function sendTrackingData(tenantId, data) {
  const tenantTrackingAPI = {
    payback: PAYBACK_SERVICE_URL.V1.TRACKING,
  };
  const url = tenantTrackingAPI[tenantId];
  if (!url) {
    return Promise.resolve(null);
  }
  const payload = JSON.stringify(data);
  // beacon runs in background even if the page unloads, redirects, or closes immediately after triggering it
  const sentViaBeacon = navigator.sendBeacon?.(
    url,
    new Blob([payload], { type: 'application/json' })
  );
  if (sentViaBeacon) {
    return Promise.resolve(null);
  }
  return fetch(url, {
    method: 'POST',
    headers: headers,
    body: payload,
  });
}

function postClientLog(logData) {
  return fetch(`${PAYBACK_SERVICE_URL.V1.CLIENT_LOG}`, {
    method: 'POST',
    headers: headers,
    body: '{ "message": "' + logData + '"}',
  });
}

/**
 * @deprecated
 */
async function getConfig(project) {
  console.warn('Called deprecated function getConfig in index.js');
  const backendPath = project
    ? `${constants.BACKEND_URL}/config/releasedConfig?project=` + project
    : `${constants.BACKEND_URL}/config/releasedConfig`;
  return fetch(backendPath, {
    method: 'GET',
    headers: headers,
  });
}

async function getRequiredFonts(usedFonts) {
  const url = `${constants.BACKEND_URL}/v3/formbuilder/fontResources/requiredFonts`;
  const fontParams = Array.from(usedFonts.values())
    .map((font) => `requiredFonts=${encodeURIComponent(font)}`)
    .join('&');

  return fetch(`${url}?${fontParams}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  }).then((res) => res.json());
}

async function getActiveConfigByProjectName(projectname) {
  return fetch(API.V3.PROJECT.ACTIVE_CONFIG(projectname), {
    method: 'GET',
    headers: headers,
  }).then((res) => res.json());
}

async function getConfigByVersion(projectname, version) {
  return fetch(API.V3.PROJECT.CONFIG_BY_VERSION(projectname, version), {
    method: 'GET',
    headers: headers,
  }).then((res) => res.json());
}

function sendSessionStatus(status, sessionId) {
  return fetch(`${constants.BACKEND_URL}/config/session`, {
    body: '{ "status": "' + status + '", "SessionId": "' + sessionId + '"}',
    method: 'POST',
    headers: headers,
  });
}

async function getActiveConfigTranslation(projectName, translationName) {
  return fetch(
    API.V3.TRANSLATION_RESOURCES.ACTIVE_CONFIG(projectName, translationName),
    {
      method: 'GET',
      headers,
    }
  ).then((res) => res.json());
}

async function getSpecificConfigTranslation(
  projectName,
  translationName,
  configVersion
) {
  return fetch(
    API.V3.TRANSLATION_RESOURCES.SPECIFIC_CONFIG(
      projectName,
      translationName,
      configVersion
    ),
    {
      method: 'GET',
      headers,
    }
  ).then((res) => res.json());
}

async function getAllTranslationsForConfig(projectName, configVersion) {
  return fetch(
    API.V3.TRANSLATION_RESOURCES.ALL_FROM_CONFIG(projectName, configVersion),
    {
      method: 'GET',
      headers,
    }
  ).then((res) => res.json());
}

export function formDataHeaders() {
  return {
    headers: {
      'content-type': 'multipart/form-data',
      Authorization:
        window._env_.REACT_APP_BACKEND_USERNAME +
        ':' +
        window._env_.REACT_APP_BACKEND_PASSWORD,
    },
  };
}

export function send2FACode(projectName, payload) {
  return fetch(API.V3.SAVE_AND_RETRIEVE.SEND_2FA_SAR(projectName), {
    method: 'POST',
    headers: {
      ...headers,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  }).then((res) => res.json());
}

export function verify2FACode(projectName, payload) {
  return fetch(API.V3.SAVE_AND_RETRIEVE.VERIFY_2FA_SAR(projectName), {
    method: 'POST',
    headers: {
      ...headers,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  }).then((res) => res.json());
}

export default api;
